import { render } from "./AdditionalWarnings.vue?vue&type=template&id=63db792f"
import script from "./AdditionalWarnings.vue?vue&type=script&lang=js"
export * from "./AdditionalWarnings.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__